'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const router = useRouter()

  useEffect(() => {
    // Log the error for debugging
    console.error('Global error caught:', error)
    
    // Redirect to 404 page for better SEO
    router.push('/404')
  }, [error, router])

  return (
    <html lang="vi">
      <body>
        <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center px-4 py-8">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-white mb-4">
              Đang chuyển hướng...
            </h2>
            <p className="text-[#999]">
              Vui lòng chờ trong giây lát
            </p>
          </div>
        </div>
      </body>
    </html>
  )
} 